import { render, staticRenderFns } from "./QuotaSaleCreate.vue?vue&type=template&id=474d0203&scoped=true&"
import script from "./QuotaSaleCreate.vue?vue&type=script&lang=js&"
export * from "./QuotaSaleCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuotaSaleCreate.vue?vue&type=style&index=0&id=474d0203&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474d0203",
  null
  
)

export default component.exports